import { Link } from 'react-router-dom';
import { useSettings } from '@/context/SettingsContext';
import { Phone, MapPin } from '@phosphor-icons/react';

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-20" style={{ backgroundColor: 'var(--app-footer-bg, #1C1917)', color: 'var(--app-footer-text, #D6D3D1)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-9 h-9 rounded-2xl grid place-items-center font-bold font-heading" style={{ backgroundColor: 'var(--app-primary, #0F8A43)', color: 'var(--app-button-text, #FFFFFF)' }}>MZK</span>
            <span className="font-heading font-bold text-xl text-white">{settings.store_name || 'MyZippyKart'}</span>
          </div>
          <p className="text-sm max-w-sm leading-relaxed opacity-80">
            Fresh grocery and daily essentials delivered to your doorstep. Currently serving Faridabad, Ballabgarh and nearby serviceable areas. Cash on Delivery available.
          </p>
          <div className="mt-4 space-y-1.5 text-sm">
            <p className="flex items-center gap-2" data-testid="footer-store-phone"><Phone size={14} weight="duotone" /> {settings.store_phone}</p>
            <p className="flex items-center gap-2"><MapPin size={14} weight="duotone" /> India · INR</p>
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3 tracking-wide uppercase">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-terracotta-300">All Products</Link></li>
            <li><Link to="/marketplace" className="hover:text-terracotta-300">Local Stores</Link></li>
            <li><Link to="/track" className="hover:text-terracotta-300">Track Order</Link></li>
            <li><Link to="/seller/register" className="hover:text-terracotta-300">Sell with us</Link></li>
            <li><Link to="/shop?q=fresh" className="hover:text-terracotta-300">Fresh Picks</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3 tracking-wide uppercase">Help</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-terracotta-300">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-terracotta-300">Contact</Link></li>
            <li><Link to="/shipping" className="hover:text-terracotta-300">Shipping</Link></li>
            <li><Link to="/privacy" className="hover:text-terracotta-300">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-terracotta-300">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-4 py-4 text-xs text-stone-500 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} MyZippyKart. All rights reserved.</span>
          <span>Crafted with care · Made in India</span>
        </div>
      </div>
    </footer>
  );
}
